import { createRouter, createWebHashHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import { useStore } from 'vuex';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/studee',
    name: 'studee',
    component: function () {
      return import(/* webpackChunkName: "studee" */ '../views/StudeeView.vue');
    }
  },
  {
    path: '/mackerprod',
    name: 'mackerprod',
    component: function () {
      return import(/* webpackChunkName: "mackerprod" */ '../views/MackerView.vue');
    }
  },
  {
    path: '/duo',
    name: 'duo',
    component: function () {
      return import(/* webpackChunkName: "duo" */ '../views/DuoView.vue');
    }
  },
  {
    path: '/register',
    name: 'register',
    component: function () {
      return import(/* webpackChunkName: "register" */ '../views/Register.vue');
    }

  },
  {
    path: '/admin',
    name: 'admin',
    component: function () {
      return import(/* webpackChunkName: "admin" */ '../views/AdminView.vue');
    },
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/profil',
    name: 'profil',
    component: function () {
      return import(/* webpackChunkName: "profil" */ '../views/ProfilView.vue');
    },
    meta: { requiresAuth: true }
  },
  {
    path: '/devis',
    name: 'devis',
    component: function () {
      return import(/* webpackChunkName: "duo" */ '../views/DevisView.vue');
    },
  },
  {
    path: '/materiel',
    name: 'materiel',
    component: function () {
      return import(/* webpackChunkName: "duo" */ '../views/MaterielView.vue');
    },
  },
  {
    path: '/cgu',
    name: 'cgu',
    component: function () {
      return import(/* webpackChunkName: "duo" */ '../views/CguView.vue');
    },
  },
  {
    path: '/mentions',
    name: 'mentions',
    component: function () {
      return import(/* webpackChunkName: "duo" */ '../views/MentionsView.vue');
    },
  },
  {
    path: '/mariage',
    name: 'mariage',
    component: function () {
      return import(/* webpackChunkName: "duo" */ '../views/MariageView.vue');
    },
  },
  {
    path: '/shooting',
    name: 'shooting',
    component: function () {
      return import(/* webpackChunkName: "duo" */ '../views/ShootingView.vue');
    },
  },
  {
    path: '/evenement',
    name: 'evenement',
    component: function () {
      return import(/* webpackChunkName: "duo" */ '../views/EvenementView.vue');
    },
  },

];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

router.beforeEach(async (to, from, next) => {
  const store = useStore();

  if (to.meta.requiresAuth) {
    await store.dispatch('checkAuth');

    // Si l'utilisateur n'est pas authentifié, redirigez vers la page d'accueil
    if (!store.state.token) {
      console.warn('Accès refusé. Redirection vers la page de connexion.');
      return next('/');
    }

    // Vérifiez si l'utilisateur a le rôle 'admin' pour la route /admin
    if (to.meta.requiresAdmin && !store.getters.isAdmin) {
      console.warn('Accès refusé. L\'utilisateur n\'a pas le rôle administrateur.');
      return next('/');
    }
  }
  next();
});



export default router;

